import React from 'react';
import {
  OmniBrandContainer,
  OmniAppHeaderIconButton,
  OmniBrandHeading,
} from '../ui/appheader';
import { MdHome } from 'react-icons/md';

interface AppBrandProps {
  // Optional onClick for home navigation in the future
  onHomeClick?: () => void;
}

const AppBrand: React.FC<AppBrandProps> = ({ onHomeClick }) => {
  return (
    <OmniBrandContainer align="center" gap={[1, 2]}>
      <OmniAppHeaderIconButton
        variant="contrast"
        aria-label="Home"
        size="md"
        onClick={onHomeClick}
      >
        <MdHome />
      </OmniAppHeaderIconButton>

      <OmniBrandHeading
        variant="contrast"
        size="md"
        fontSize={['md', 'lg', 'xl', '2xl']}
      >
        Data Explorer
      </OmniBrandHeading>
    </OmniBrandContainer>
  );
};

export default AppBrand;
